module.exports = __webpack_public_path__ + "img/zxxnfzpt.d9ba8b81.png";